
<template>
  <div>
      
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue